import React from 'react';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketDashboard } from '../components/MarketDashboard';
import { ChickenPricingTable } from '../components/ChickenPricingTable';
import { MarketIQNav } from '../components/MarketIQNav';
import { MapIcon } from 'lucide-react';
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const generateCurve = (base: number, volatility: number, trend: number, length: number) => {
  let current = base;
  return Array.from({
    length
  }).map(() => {
    current += (Math.random() - 0.5) * volatility + trend;
    return Number(current.toFixed(2));
  });
};
const chicken2024 = generateCurve(130, 0.5, 0.1, 12);
const chicken2025 = generateCurve(135, 0.6, -0.2, 12);
const chicken2026 = generateCurve(129, 0.4, 0.05, 4);
const chickenData = months.map((month, i) => ({
  month,
  val2024: chicken2024[i],
  val2025: chicken2025[i],
  val2026: i < 4 ? chicken2026[i] : null
}));
export function MarketIQChicken() {
  return <MarketIQLayout activeSection="chicken" data-id="element-524">
      <MarketDashboard label="LIVE CHICKEN" title="Live Chicken Report" subtitle="Current pricing and weekly analysis for live chicken values" chartTitle="Whole Body Trading by Size - National Composite ($/lb)" currentPrice="$1.29" currentPriceNum={1.29} priceChange={{
      value: '$0.01',
      isNegative: true
    }} historicalChanges={[{
      label: '1W',
      value: '$0.01',
      isNegative: true
    }, {
      label: '1M',
      value: '+$0.01',
      isNegative: false
    }, {
      label: '1Y',
      value: '$0.05',
      isNegative: true
    }]} lastReportDate="Apr 3, 2026" filters={[{
      icon: <MapIcon className="w-4 h-4" data-id="element-526" />,
      label: 'National'
    }]} chartData={chickenData} yAxisDomain={[123, 138]} yAxisTicks={[123, 126, 129, 132, 135, 138]} data-id="element-525" />
      <MarketIQNav current="chicken" data-id="element-527" />
      <ChickenPricingTable data-id="element-528" />
    </MarketIQLayout>;
}